import React from 'react';
import { getChampionIconUrl } from '../../lib/champions';

/**
 * APEX v8.13 — ChampIcon
 *
 * Icône de champion compacte, gère le cas où le champion n'est pas trouvé
 * dans la liste DataDragon (fallback placeholder).
 *
 * Extrait de App.jsx v8.13 (était inline avec SessionTab).
 */
export default function ChampIcon({ name, champions, version, size = 32 }) {
  const champ = champions?.find(c => c.name === name || c.id === name);
  if (!champ) return <div className="bg-zinc-800" style={{ width: size, height: size }} />;
  return (
    <img
      src={getChampionIconUrl(champ.id, version)}
      alt={name}
      style={{ width: size, height: size }}
      className="object-cover flex-shrink-0"
      loading="lazy"
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
    />
  );
}
